import type { ICustomControlSupervisionReadProps } from '../../interfaces/';
import { FormParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';

export function TpoV1SupervisionGradingSummary(props: ICustomControlSupervisionReadProps) {
    if (!props.supervision.customControlData || !props.supervision.customControlData.diagnostische_overweging) {
        return null;
    }

    return (
        <HorizontalFormGroupRead>
            <FormLabel>Diagnostische overweging</FormLabel>
            <InputContainer>
                <FormParagraph>{props.supervision.customControlData.diagnostische_overweging}</FormParagraph>
            </InputContainer>
        </HorizontalFormGroupRead>
    );
}
